/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAgentRunsQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListAgentRunsQueryParamOrder = ClosedEnum<
  typeof ListAgentRunsQueryParamOrder
>;

export type ListAgentRunsRequest = {
  agentId: string;
  limit?: number | undefined;
  order?: ListAgentRunsQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListAgentRunsQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListAgentRunsQueryParamOrder
> = z.nativeEnum(ListAgentRunsQueryParamOrder);
/** @internal */
export const ListAgentRunsQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListAgentRunsQueryParamOrder
> = ListAgentRunsQueryParamOrder$inboundSchema;

/** @internal */
export const ListAgentRunsRequest$inboundSchema: z.ZodType<
  ListAgentRunsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentRunsQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListAgentRunsRequest$Outbound = {
  agent_id: string;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListAgentRunsRequest$outboundSchema: z.ZodType<
  ListAgentRunsRequest$Outbound,
  z.ZodTypeDef,
  ListAgentRunsRequest
> = z.object({
  agentId: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentRunsQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listAgentRunsRequestToJSON(
  listAgentRunsRequest: ListAgentRunsRequest,
): string {
  return JSON.stringify(
    ListAgentRunsRequest$outboundSchema.parse(listAgentRunsRequest),
  );
}
export function listAgentRunsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentRunsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentRunsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentRunsRequest' from JSON`,
  );
}
